import React, { useState, useEffect, lazy, useContext, useMemo } from "react";
import "./EditHardwareRequestComponent.css";
import { Dropdown } from "primereact/dropdown"; // <-- 1. IMPORT THE COMPONENT
import { DropdownSelect } from "@vds/selects";
import { Button } from "@vds/buttons";
import { Icon } from "@vds/icons";
import PropTypes from "prop-types";
import styles from "./../../../../src/C4S Decommission - Replacement/components/core/CustomModal/index";
import { Loader } from "@vds/loaders";

import { getMaterialMappings, retrieveBundleFiles } from "../../services/C4S Decommission - Replacement/editVehicleWTA";
import { ViewVehicleList } from "../../../C4S Decommission - Replacement/services/C4S Decommission - Replacement/viewVehicleList";
import { updateHardware } from "../../services/C4S Decommission - Replacement/editHardwareRequest";
import isArray from "lodash/isArray";
import { PrivilegeContext } from "../../../context/privilegeContext";
import AddMaterial from "../EditVehicleWTA/AddMaterial";
import { generate } from "shortid";
import { Breadcrumbs, BreadcrumbItem } from "@vds/breadcrumbs";
import { Spacer } from "../../components/core/utility";
import { messageBus } from "../../../../src/utility/messageBus";
import { handleChangePage, switchTab, redirectToPrevPage } from "./../C4S Decommission - Replacement/utils";
import { navigateToCSPOrder, getHardwareApprovalrequest } from "../../services/C4S Decommission - Replacement/getHardwareApprovalList";
import uploadStyles from "./../../../C4S Decommission - Replacement/components/core/CustomUploadFile/CustomUploadFile.module.css";
import { Tooltip } from "primereact/tooltip";
import { notify } from "../../../../src/utility/getProperty";
import { getContractDetails } from "../../services/C4S Decommission - Replacement/getMMIDList";
import { HARDWARE_REQUEST_STATUS } from "../EditVehicleWTA/EditVehicleConstants";
import pdfIcon from "./../../../assets/icons/export-pdf.png";

const EditHardwareRequestComponent = ({ data: requestData }) => {
  const { cspInfo } = useContext(PrivilegeContext);
  const cspData = cspInfo?.data?.data;
  const isDisabled = requestData?.status !== "CREATED";
  const [request, setRequest] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reportToSpecifier, setReportToSpecifier] = useState(false);
  const [approvalHardware, setApprovalHardware] = useState([]);
  const [comments, setComments] = useState("");
  const [currentImages, setCurrentImages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [materialResponse, setMaterialResponse] = useState(null);
  const [groupedRecomendationsSubscriptionId, setGroupedRecomendationsSubscriptionId] = useState({});
  const [addedMaterials, setAddedMaterials] = useState([]);
  const [existingHardwareRequest, setExistingHardwareRequest] = useState(null);
  const [isAddMaterialModalOpen, setIsAddMaterialModalOpen] = useState(false);
  const [materialsAndPriorities, setMaterialsAndPriorities] = useState();
  const [hardwareSelected, setHardwareSelected] = useState(null);
  const [vechileData, setVechileData] = useState([]);
  const [tooltipContent, setTooltipContent] = useState("");
  const [materialMapping, setMatrialMapping] = useState("");
  const [approvalHardwareFromDropdown, setApprovalHardwareFromDropdown] = useState({});
  const [commentError, setCommentError] = useState("");
  const [notification, setNotification] = useState();
  const [requestVehicle, setRequestVehicle] = useState("");
  const [currentVehicleApiData, setCurrentVehicleApiData] = useState({});
  const [hardwareSelections, setHardwareSelections] = useState({});
  const [selectedAddMaterialsGroupedSubs, setSelectedAddMaterialsGroupedSubs] = useState({});
  const [displayVin, setDisplayVin] = useState("");

  const MAX_IMAGES = 3;
  const showCustomAlert = (message, type) => {};

  // Treat CLEARED same as CANCELLED for UI behavior (disable actions, show Cancelled)
  const isCancelled = (() => {
    const st = String(requestData?.status || "").toUpperCase();
    return st === "CANCELLED" || st === "CLEARED";
  })();

  const filterSelectedd = (groupedRecommendations) => {
    const selectedIds = new Set(Object.values(hardwareSelections).flatMap(Object.values));

    const filteredGroup = {};

    for (const subscriptionId in groupedRecommendations) {
      const materials = groupedRecommendations[subscriptionId];

      const availableMaterials = materials.filter((material) => !selectedIds.has(material.materialId));
      const sortedMaterials = availableMaterials
        ?.filter((item) => String(item.materialId)?.startsWith("11") && !item.isObsolete)
        ?.sort((a, b) => String(a.materialId)?.localeCompare(String(b.materialId)));

      if (sortedMaterials?.length > 0) {
        filteredGroup[subscriptionId] = sortedMaterials;
      }
    }

    return filteredGroup;
  };

  useEffect(() => {
    if (!requestData || !Array.isArray(requestData.currentHardwareMapping)) {
      setTooltipContent("No subscriptions");
      return; // Exit the effect early.
    }

    let uniqueNames = requestData.currentHardwareMapping.map((item) => item?.subscriptionName).filter(Boolean);
    uniqueNames = Array.from(new Set(uniqueNames));

    const newContent = uniqueNames.length ? uniqueNames.join("\n") : "No subscriptions";
    setTooltipContent(newContent);
  }, [Object.keys(requestData)?.length]);

  const Modal = ({ show, onClose, children }) => {
    if (!show) {
      return null;
    }

    return (
      <div className={uploadStyles.modalBackdrop} onClick={onClose}>
        <div className={uploadStyles.modalContent} onClick={(e) => e.stopPropagation()}>
          <span className={uploadStyles.modalCloseButton} onClick={onClose}>
            &times;
          </span>
          {children}
        </div>
      </div>
    );
  };

  Modal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
  };

  const transformVehicleData = (apiData) => {
    // Get the first vehicle from the response
    const vehicleKey = Object.keys(apiData.vehicles)[0];
    if (!vehicleKey || !apiData.vehicles[vehicleKey]?.[0]) {
      return []; // Return empty if data structure is unexpected
    }

    const materialMappingVechicle = apiData.vehicles[vehicleKey]?.find((veh) => Number(requestData.vehicleId) == Number(veh.id))?.materialMapping;
    setMatrialMapping(materialMappingVechicle);

    const groupedBySubscription = materialMappingVechicle.reduce((acc, material) => {
      const { subscriptionId, subscriptionName, techRefId, hardwareId, hardwareName, type } = material;

      if (!acc[subscriptionId]) {
        acc[subscriptionId] = {
          subscriptionId: subscriptionId,
          name: subscriptionName,
          techRefId: techRefId, // Taking the Tech Ref ID from the first item found for this subscription
          type: type, // Taking the type from the first item found
          currentHardware: [], // Assuming current hardware is empty or from another source
          requestedHardware: [], // This is what we'll populate from the API
        };
      }

      acc[subscriptionId].requestedHardware.push({
        id: hardwareId,
        name: hardwareName,
      });

      return acc;
    }, {});

    return Object.values(groupedBySubscription);
  };

  useEffect(() => {
    if (materialMapping !== undefined) {
      return;
    }
  }, [materialMapping]);

  const subscriptionIdToInstallTypeMap = useMemo(() => {
    const { deviceType } = currentVehicleApiData || {};
    const subscriptionsList =
      cspData.Product?.filter((p) => p.BundleId === requestData.bundleId && p.AssetType.toLowerCase() === deviceType.toLowerCase()) || [];

    const map = subscriptionsList.reduce((acc, product) => {
      acc[String(product.SAPProductID)] = product.InstallationType;
      return acc;
    }, {});
    return map;
  }, [cspData, requestData.bundleId, currentVehicleApiData]);

  const onHyperLinkClick = (data) => {
    navigateToCSPOrder(data.cspId);
    return;
  };

  const prepareHardwareApiPayload = (apiData) => {
    if (!cspInfo?.data?.data) return null;

    const cspData = cspInfo.data.data;
    const products = cspData.Product || [];

    const coreProducts = products.filter(
      (product) =>
        product?.BundleId === requestData?.bundle &&
        product.featureType === "CORE" &&
        product.AssetType.toLowerCase() === apiData?.deviceType?.toLowerCase()
    );

    if (!coreProducts.length) return null;

    const payload = {
      vinList: [
        {
          id: apiData?.id,
          vin: apiData?.vehicle,
          year: apiData?.year,
          make: apiData?.make,
          model: apiData?.model,
          killSwitch: apiData?.killSwitch,
          emergency: apiData?.emergency,
          wheelChair: apiData?.wheelChair,
          weightClass: apiData?.class || true,
          fuelType: apiData?.fuelType,
        },
      ],
      type: apiData?.deviceType?.startsWith("VIN") ? "YMM" : apiData?.deviceType?.startsWith("AST") ? "ASSET" : "VEHICLE",
      countryCode: cspData.BillingCountry,
      salesOrgId: cspData.CSP?.[0]?.Opp_Sales_Org,
      productPlatform: cspData.ProductPlatform,
      accountBrand: cspData.Account_Brand,
      vehicleSubscriptions: [],
    };
    const subscriptions = {};

    coreProducts.forEach((product) => {
      const subscription = product.SAPProductID;
      const techRefId = product.TechRefId;

      if (!subscriptions[subscription]) {
        subscriptions[subscription] = {
          subscription,
          techRefId,
          vehicleFeatures: [],
        };
      }

      const features = products.filter(
        (p) => p.BundleId === requestData?.bundle && p.featureType === "FEATURE" && p?.AssetType?.toLowerCase() === apiData?.deviceType?.toLowerCase()
      );

      features.forEach((feature) => {
        subscriptions[subscription].vehicleFeatures.push({
          materialId: feature.SAPProductID,
          techRefId: feature.TechRefId,
        });
      });
    });

    payload.vehicleSubscriptions = Object.values(subscriptions);
    return payload;
  };

  const handleReportToSpecifierChange = (event) => {
    setReportToSpecifier(event.target.checked);
    if (event.target.checked) {
      return;
    }
  };
  const redirectToPrevPageAndRefresh = () => {
    location.reload();
  };
  const handleSendApproval = async () => {
    try {
      if (!comments.trim()) {
        setCommentError("Comments are required.");
        notify("Comments are required.", "error", setNotification);
        return;
      }
      setCommentError("");
      const approvedHardwareMapping = [];

      requestVehicle?.requestedHardwareMapping?.forEach((originalHardware) => {
        const subId = originalHardware.subscriptionId;
        const originalId = originalHardware.materialId;

        const finalMaterialId = hardwareSelections[subId]?.[originalId] ?? originalId;

        if (finalMaterialId) {
          const materialDetails = groupedRecomendationsSubscriptionId[subId]?.find((rec) => rec.materialId === finalMaterialId);

          if (materialDetails) {
            approvedHardwareMapping.push({
              subscriptionName: originalHardware.subscriptionName || materialDetails.subscriptionName || "N/A",
              subscriptionId: subId,
              techRefId: originalHardware.techRefId || materialDetails.techRefId || "N/A",
              materialId: finalMaterialId,
              materialName: materialDetails.materialName,
              deviceType: request.deviceType,
              crmRefId: requestData.crmRefId,
              lineType: originalHardware?.lineType,
              ...(originalHardware?.originalVinMaterial && { originalVinMaterial: originalHardware.originalVinMaterial }),
              installType: subscriptionIdToInstallTypeMap[String(subId)] || null,
            });
          }
        }
      });
      const isHardwareChanged = hasAnyHardwareChanged();
      if ((isHardwareChanged && hardwareSelections) || (addedMaterials && addedMaterials.length > 0)) {
        if (addedMaterials && addedMaterials.length > 0) {
          addedMaterials.forEach((newMaterial) => {
            const parentSubscription = request.subscriptions.find((sub) => sub.subscriptionId === newMaterial.subscriptionId);
            approvedHardwareMapping.push({
              subscriptionName: parentSubscription?.name || "N/A",
              subscriptionId: newMaterial.subscriptionId,
              techRefId: parentSubscription?.techRefId || "N/A",
              materialId: newMaterial.materialId,
              materialName: newMaterial.materialName,
              deviceType: request.deviceType,
              crmRefId: requestData.crmRefId,
              lineType: newMaterial?.lineType,
              installType: subscriptionIdToInstallTypeMap[String(newMaterial.subscriptionId)] || null,
            });
          });
        }

        const payload = {
          action: "HARDWARE_APPROVE_CHANGE",
          bundle: requestData.bundle,
          order: requestData.order,
          accountName: requestData.accountName,
          deploymentAgent: requestData.deploymentAgent,
          hardwareAgent: requestData.deploymentAgent,
          reasonForChange: requestData.reasonForChange,
          approvedHardwareMapping: approvedHardwareMapping,
          salesOrgId: cspData.CSP?.[0]?.Opp_Sales_Org,
          bundleOrderType: requestData.bundle,
          crmRefId: requestData.crmRefId,
          approvalComments: comments,
          comment: comments,
        };
        if (!requestVehicle.requestedHardwareMapping.length && !addedMaterials.length) {
          notify("Approval hardware is empty, can not send approval.", "error", setNotification);
          return;
        }
        const response = await updateHardware(payload, requestData.id);
        if (response.status === 200) {
          notify(response?.data?.message ?? "Approval has been sent successfully!", "success", setNotification);

          setTimeout(() => {
            redirectToPrevPageAndRefresh();
          }, 2000);
        } else {
          notify(response?.data ?? "Failed to send approval", "error", setNotification);
        }
      } else {
        if (addedMaterials && addedMaterials.length > 0) {
          addedMaterials.forEach((newMaterial) => {
            const parentSubscription = request.subscriptions.find((sub) => sub.subscriptionId === newMaterial.subscriptionId);
            approvedHardwareMapping.push({
              subscriptionName: parentSubscription?.name || "N/A",
              subscriptionId: newMaterial.subscriptionId,
              techRefId: parentSubscription?.techRefId || "N/A",
              materialId: newMaterial.materialId,
              materialName: newMaterial.materialName,
              deviceType: request.deviceType,
              crmRefId: requestData.crmRefId,
              lineType: newMaterial?.lineType,
              installType: subscriptionIdToInstallTypeMap[String(newMaterial.subscriptionId)] || null,
            });
          });
        }

        const payload = {
          action: "HARDWARE_APPROVE_NO_CHANGE",
          hardwareAgent: requestData.deploymentAgent,
          approvalComments: comments,
          crmRefId: requestData.crmRefId,
          salesOrgId: cspData.CSP?.[0]?.Opp_Sales_Org,
          bundle: requestData.bundle,
          approvedHardwareMapping: approvedHardwareMapping,
          order: requestData.order,
          accountName: requestData.accountName,
        };
        if (!requestVehicle.requestedHardwareMapping.length && !addedMaterials.length) {
          notify("Approval hardware is empty, can not send approval.", "error", setNotification);
          return;
        }
        const response = await updateHardware(payload, requestData.id);
        if (response.status === 200) {
          notify(response?.data?.message ?? "Approval has been sent successfully!", "success", setNotification);
          setTimeout(() => {
            redirectToPrevPageAndRefresh();
          }, 2000);
        } else {
          notify(response?.data ?? "Failed to send approval", "error", setNotification);
        }
      }
    } catch (err) {
      setError(err.message);
      showCustomAlert(`Failed to send approval: ${err.message}`, "error");
      notify(err.message ?? "Failed to send approval", "error", setNotification);
    }
  };

  const handleUseCurrent = async () => {
    try {
      if (!comments.trim()) {
        setCommentError("Comments are required ");
        notify("Comments are required.", "error", setNotification);
        return;
      }
      setCommentError(""); // Clear error if comments are provided
      if (!requestVehicle.assignedHardwareMapping.some((item) => item.materialId || item.materialName)) {
        notify("Current hardware is empty, cannot use current.", "error", setNotification);
        return;
      }
      const payload = {
        action: "HARDWARE_USE_CURRENT",
        hardwareAgent: requestData.deploymentAgent,
        approvalComments: comments, // Comments are now included
        crmRefId: requestData.crmRefId,
        salesOrgId: cspData.CSP?.[0]?.Opp_Sales_Org,
        bundle: requestData.bundle,
        order: requestData.order,
        accountName: requestData.accountName,
      };

      const response = await updateHardware(payload, requestData.id);

      if (response.status === 200) {
        notify(response?.data?.message ?? "Successfully set to 'Use Current Hardware'.", "success", setNotification);
        setTimeout(() => {
          redirectToPrevPageAndRefresh();
        }, 2000);
      } else {
        notify(response?.data ?? "Failed to update status.", "error", setNotification);
      }
    } catch (err) {
      setError(err.message);
      notify(err.message ?? "An unexpected error occurred.", "error", setNotification);
    }
  };

  const commentsAreMandatory = () => {
    if (!request || Object.keys(approvalHardwareFromDropdown)?.length === 0) return false;

    let isTrue = false;
    request.subscriptions.some((subscription) =>
      subscription.requestedHardware.some((device) => {
        const originalId = device.id;
        const selectedValue = approvalHardwareFromDropdown[originalId];

        if (selectedValue === "selectHardware") {
          isTrue = true;
        }

        if (selectedValue && selectedValue !== originalId) {
          isTrue = true;
        }
      })
    );
    return isTrue;
  };

  useEffect(() => {
    const fetchHardwareApproval = async () => {
      try {
        setIsLoading(true);
        const hwreqid = requestData?.id;
        const hwRequestResponse = await getHardwareApprovalrequest(0, 1, hwreqid);
        if (hwRequestResponse.status !== 200 || !hwRequestResponse?.data?.data?.requests[0]) {
          notify("Unable to fetch hardware approval request details", "error");
          // setIsLoading(false);
        }

        const vehicleRequest = hwRequestResponse.data.data.requests[0];
        setRequestVehicle(vehicleRequest);

        const response = await ViewVehicleList(
          requestData.bundle,
          requestData.addressId,
          requestData.contactId,
          requestData.crmRefId,
          undefined,
          requestData.vehicleId
        );
        if (response.status >= 200 && response.status < 300) {
          const vehicleKey = Object.keys(response?.data?.data?.vehicles)[0];
          const vehicleApiData = response?.data?.data?.vehicles[vehicleKey][0];

          setDisplayVin(response?.data?.data?.vehicles[vehicleKey][0].displayVinId);
          setCurrentVehicleApiData(vehicleApiData);
          const formattedSubscriptions = transformVehicleData(response?.data?.data);

          const fullRequestObject = {
            ...requestData, // Use the static details

            vehicle: {
              year: vehicleApiData.year,
              make: vehicleApiData.make,
              model: vehicleApiData.model,
              vin: vehicleApiData.vehicle,
              class: vehicleApiData.weightClass,
              images: [], // Add image paths if available from API
              comment: vehicleApiData.comment,
              reason: vehicleApiData.reason,
              killSwitch: vehicleApiData.killSwitch,
              wheelChair: vehicleApiData.wheelChair,
              emergency: vehicleApiData.emergency,
              fuelType: vehicleApiData.fuelType,
            },
            subscriptions: formattedSubscriptions, // Use formatted subscriptions from API
            deviceType: vehicleApiData.deviceType,
          };
          fetchExistingFiles(fullRequestObject);

          //  Update the main request state
          setRequest(fullRequestObject);

          // Set the approvalHardware state now that 'request' is populated
          setApprovalHardware(requestData?.requestedHardwareMapping);

          // const recommendations = fullRequestObject.requestedHardwareMapping || [];
          const subscriptionList = [...new Set(vehicleRequest?.requestedHardwareMapping?.map((e) => e.subscriptionId))];
          const contractDetailsPromises = subscriptionList.map((subId) => getContractDetails(subId, cspData.CSP?.[0]?.Opp_Sales_Org));
          const contractDetailsResponses = await Promise.all(contractDetailsPromises);
          const approvalMaterialList = contractDetailsResponses.reduce((acc, res) => {
            if (res?.status === 200 && res?.data?.data?.length) {
              acc[res.data.data[0].sapId] = res.data.data.map((e) => ({
                materialId: e.materialId,
                materialName: e.materialName,
                subscriptionId: e.sapId,
                subscriptionName: e.contractName,
                techRefId: vehicleApiData?.materialMapping?.find((v) => v.subscriptionId === e.sapId)?.techRefId || null,
              }));
            }
            return acc;
          }, {});

          const allMaterialsArrays = Object.values(approvalMaterialList);

          const flatMaterialList = allMaterialsArrays.flat();

          const groupedBySubscriptionId = flatMaterialList?.reduce((acc, currentRecommendation) => {
            const { subscriptionId } = currentRecommendation;

            if (!acc[subscriptionId]) {
              acc[subscriptionId] = [];
            }

            acc[subscriptionId].push(currentRecommendation);
            return acc;
          }, {});

          setGroupedRecomendationsSubscriptionId(groupedBySubscriptionId);
        } else {
          throw new Error(`Failed to fetch data: Status ${response.status}`);
        }
        setIsLoading(false);
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    };

    fetchHardwareApproval();
  }, [requestData]);

  const fetchExistingFiles = async (vehicleApiData) => {
    if (!vehicleApiData?.vehicle?.vin || !vehicleApiData?.bundle) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    try {
      const response = await retrieveBundleFiles(vehicleApiData?.vehicle.vin, vehicleApiData?.bundle);

      if (response.status >= 200 && response.status < 300) {
        const fetchedFilesData = response.data?.data;

        if (!Array.isArray(fetchedFilesData)) {
          showCustomAlert("Invalid data format received from API. Expected an array of URLs.", "error");
          throw new Error("Invalid data format received from API. Expected an array of URLs.");
        }

        const mappedFilesPromises = fetchedFilesData.map(async (fileUrl) => {
          if (typeof fileUrl !== "string") {
            return null;
          }

          const urlParts = fileUrl.split("/");
          const fileNameWithParams = urlParts[urlParts.length - 1];
          const fileName = fileNameWithParams.split("?")[0];

          const fileType = fileName?.toLowerCase().endsWith(".pdf")
            ? "application/pdf"
            : fileName.toLowerCase().endsWith(".png") || fileName?.toLowerCase().endsWith(".jpg") || fileName?.toLowerCase().endsWith(".jpeg")
            ? "image/"
            : "unknown";

          let fileSrc = "";

          if (fileType === "application/pdf") {
            fileSrc = pdfIcon;
            if (!pdfIcon) {
              showCustomAlert("PDF icon is missing for PDF files.", "error");
            }
          } else if (fileType.startsWith("image/")) {
            fileSrc = fileUrl;
          } else {
            // For unknown types, you might use a generic fallback icon or URL
            fileSrc = "https://placehold.co/150x150/cccccc/333333?text=Unknown"; // Generic fallback
          }

          return {
            id: fileUrl,
            name: decodeURIComponent(fileName),
            src: fileSrc,
            file: null,
            type: fileType,
            isExisting: true,
            originalUrl: fileType.startsWith("image/") ? fileUrl : undefined,
          };
        });

        const resolvedMappedFiles = (await Promise.all(mappedFilesPromises)).filter(Boolean);
        setCurrentImages(resolvedMappedFiles);
      } else {
        const errorMessage = response.data?.message || `Status: ${response.status}, text: ${response.statusText || "Unknown error"}`;

        showCustomAlert(`Failed to retrieve existing files: ${errorMessage}`, "error");
      }
    } catch (error) {
      showCustomAlert(`Error retrieving existing files. Please try again. Details: ${error.message || "Unknown error"}`, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const isHardwareSelectionChanged = (subscriptionId, materialsAdded) => {
    // Get the currently selected value from the dropdown state
    const selectedValue = hardwareSelections[subscriptionId];
    if (materialsAdded?.length > 0) {
      return true;
    }

    // If no selection has been made in the dropdown, no change occurred
    if (!selectedValue) {
      return false;
    }

    // Get the original requested hardware for this subscription
    const originalRequestedHardware = requestVehicle?.requestedHardwareMapping?.find((hardware) => hardware.subscriptionId === subscriptionId);

    // If no original hardware exists, any selection is considered a change
    if (!originalRequestedHardware || materialsAdded?.length > 0) {
      return true;
    }

    // Compare the selected value with the original material ID
    return selectedValue !== originalRequestedHardware.materialId;
  };

  const hasAnyHardwareChanged = (materialsAdded) => {
    if (!request || !request.subscriptions) {
      return false;
    }

    return request.subscriptions.some((subscription) => isHardwareSelectionChanged(subscription.subscriptionId, materialsAdded));
  };

  const existingHardwareMapForModal = React.useMemo(() => {
    if (!request?.subscriptions || !requestVehicle?.requestedHardwareMapping || !groupedRecomendationsSubscriptionId) {
      return {};
    }

    return request.subscriptions.reduce((acc, subscription) => {
      const subId = subscription.subscriptionId;
      const dropdownSelection = hardwareSelections[subId];

      if (dropdownSelection) {
        const allMaterialsForSub = groupedRecomendationsSubscriptionId[subId] || [];
        const isValidSelection = allMaterialsForSub.some((m) => m.materialId === dropdownSelection);

        if (isValidSelection) {
          acc[subId] = [dropdownSelection];
        }
      } else {
        const initialHardwareIds = requestVehicle.requestedHardwareMapping.filter((h) => h.subscriptionId === subId).map((h) => h.materialId);

        if (initialHardwareIds.length > 0) {
          acc[subId] = initialHardwareIds;
        }
      }

      return acc;
    }, {});
  }, [request?.subscriptions, requestVehicle?.requestedHardwareMapping, approvalHardwareFromDropdown, groupedRecomendationsSubscriptionId]);

  const handlePreviewClick = (fileData) => {
    if (fileData.type.startsWith("image/")) {
      setModalContent(<img src={fileData.src} alt={fileData.name} className={styles.modalImage} />);
      setShowModal(true);
    } else if (fileData.type === "application/pdf") {
      let pdfUrl = null;
      let revokeNeeded = false;
      try {
        if (fileData.file instanceof Blob) {
          pdfUrl = URL.createObjectURL(fileData.file);
          revokeNeeded = true;
        } else if (typeof fileData.id === "string") {
          pdfUrl = fileData.id; // existing URL
        }
        if (pdfUrl) {
          window.open(pdfUrl, "_blank", "noopener,noreferrer");
          if (revokeNeeded) {
            setTimeout(() => URL.revokeObjectURL(pdfUrl), 4000);
          }
        } else {
          notify("Unable to open PDF: invalid file reference", "error", setNotification);
        }
      } catch (e) {
        notify("Unable to open PDF", "error", setNotification);
        if (pdfUrl && revokeNeeded) {
          URL.revokeObjectURL(pdfUrl);
        }
      }
    }
  };
  const traitToIconMap = {
    emergency: {
      name: "police-fleet",
      className: "police-fleet",
      ariaLabel: "police-fleet",
    },
    wheelChair: {
      name: "international-symbol-of-access",
      className: "trash-icon",
      ariaLabel: "InternationalSymbolOfAccess",
    },
    killSwitch: {
      name: "smart-switch",
      className: "smart-switch",
      ariaLabel: "smart-switch",
    },
  };

  const getAddMaterialSubscriptionsList = async (subscriptionId, salesOrg) => {
    try {
      const response = await getContractDetails(subscriptionId, salesOrg);
      if (response && response.status === 200 && response?.data?.data) {
        let materials = response.data.data.map((item) => {
          return {
            materialId: item.materialId,
            materialName: item.materialName,
            label: `${item.materialName} - ${item.materialId}`,
            subscriptionId: item.sapId,
            subscriptionName: item.contractName,
          };
        });
      }
    } catch (err) {
      showCustomAlert(
        `Error fetching materials of subscription ${subscriptionId} Please try again. Details: ${error.message || "Unknown error"}`,
        "error"
      );
    }
  };

  async function handleGetContractDetails(subscriptionId) {
    try {
      const response = await getContractDetails(subscriptionId, cspData?.CSP?.[0]?.Opp_Sales_Org);
      if (response && response.status === 200 && response?.data?.data) {
        let materials = response?.data?.data?.map((item) => {
          return {
            materialId: item.materialId,
            materialName: item.materialName,
            label: `${item.materialName} - ${item.materialId}`,
            subscriptionId: item.sapId,
            subscriptionName: item.contractName,
            techRefId: currentVehicleApiData?.materialMapping?.find((v) => v.subscriptionId === subscriptionId)?.techRefId || null,
          };
        });
        const sortedMaterials = materials
          ?.filter((item) => String(item.materialId)?.startsWith("11") && !item.isObsolete)
          ?.sort((a, b) => String(a.materialId)?.localeCompare(String(b.materialId)));
        if (sortedMaterials?.length > 0) {
          let groupedSubs = {};
          groupedSubs[subscriptionId] = sortedMaterials || [];
          setSelectedAddMaterialsGroupedSubs((previousState) => ({
            ...previousState,
            [subscriptionId]: sortedMaterials,
          }));
        }
      }
    } catch (err) {
      showCustomAlert(
        `Error fetching materials of subscription ${subscriptionId} Please try again. Details: ${error.message || "Unknown error"}`,
        "error"
      );
    }
  }

  // Helper: determine if a subscription should be locked (row grayed and dropdown disabled)
  const isSubscriptionLocked = (subscriptionId) => {
    try {
      const mappingArray = Array.isArray(materialMapping)
        ? materialMapping
        : Array.isArray(currentVehicleApiData?.materialMapping)
        ? currentVehicleApiData.materialMapping
        : [];
      return mappingArray?.some((m) => String(m.subscriptionId) === String(subscriptionId) && m?.workTicketId != null);
    } catch (e) {
      return false;
    }
  };

  const isButtonDisabled =
    !request || requestData?.status !== "CREATED" || !requestVehicle.assignedHardwareMapping.some((item) => item.materialId || item.materialName);

  const renderRequestedHardwareMapping = (requestVehicle, subscription) => {
    const mainItemsAssigned = [];
    const accessoryItemsAssigned = [];

    const assignedHardwareMappingObj =
      requestVehicle?.assignedHardwareMapping?.filter((r) => String(r.subscriptionId) === String(subscription.subscriptionId)) || [];
    // Separate items by subType assignedHardwareMapping
    assignedHardwareMappingObj.forEach((item) => {
      if (item.subType?.toLowerCase() === "main") {
        mainItemsAssigned.push(item);
      } else {
        accessoryItemsAssigned.push(item);
      }
    });

    const mainItems = [];
    const accessoryItems = [];

    const requestedHardwareMappingObj =
      requestVehicle?.requestedHardwareMapping?.filter((r) => String(r.subscriptionId) === String(subscription.subscriptionId)) || [];

    // Separate items by subType requestedHardwareMapping
    requestedHardwareMappingObj.forEach((item) => {
      if (item.subType?.toLowerCase() === "main") {
        mainItems.push(item);
      } else {
        accessoryItems.push(item);
      }
    });

    const textStyle = {
      color: requestData?.status !== "CREATED" ? "#6F7171" : "#000",
    };

    const renderItems = (items) => {
      if (items.length === 0) {
        return (
          <div key="1" style={{ minHeight: "3.2rem" }}>
            <div style={textStyle}>
              <span style={{ color: "#6F7171" }}>--</span>
            </div>
          </div>
        );
      }

      return items.map((reqItem, idx) => (
        <div key={idx} style={{ marginBottom: "10px", minHeight: "3.2rem" }}>
          <div style={textStyle}>
            {reqItem.materialName}
            <br />({reqItem.materialId})
          </div>
        </div>
      ));
    };

    return (
      <>
        {mainItems.length === 0 && accessoryItems.length === 0 ? (
          <span style={{ color: "#6F7171" }}>--</span>
        ) : (
          <>
            {mainItemsAssigned && mainItemsAssigned.length > 0
              ? renderItems(mainItems)
              : mainItems && mainItems.length > 0
              ? renderItems(mainItems)
              : null}
            {accessoryItemsAssigned && accessoryItemsAssigned.length > 0
              ? renderItems(accessoryItems)
              : accessoryItems && accessoryItems.length > 0
              ? renderItems(accessoryItems)
              : null}
          </>
        )}
      </>
    );
  };

  const renderApprobvedHardwareMapping = (requestVehicle, subscription) => {
    const mainItemsAssigned = [];
    const accessoryItemsAssigned = [];
    const assignedHardwareMappingObj =
      requestVehicle?.assignedHardwareMapping?.filter((r) => String(r.subscriptionId) === String(subscription.subscriptionId)) || [];
    // Separate items by subType assignedHardwareMapping
    assignedHardwareMappingObj.forEach((item) => {
      if (item.subType?.toLowerCase() === "main") {
        mainItemsAssigned.push(item);
      } else {
        accessoryItemsAssigned.push(item);
      }
    });

    const mainItems = [];
    const accessoryItems = [];

    const approvedHardwareMappingObj =
      requestVehicle?.approvedHardwareMapping?.filter((r) => String(r.subscriptionId) === String(subscription.subscriptionId)) || [];

    // Separate items by subType
    approvedHardwareMappingObj.forEach((item) => {
      if (item.subType?.toLowerCase() === "main") {
        mainItems.push(item);
      } else {
        accessoryItems.push(item);
      }
    });

    const textStyle = {
      color: requestData?.status !== "CREATED" ? "#6F7171" : "#000",
    };

    const renderItems = (items) => {
      if (items.length === 0) {
        return (
          <div key="1" style={{ minHeight: "3.2rem" }}>
            <div style={textStyle}>
              <span style={{ color: "#6F7171" }}>--</span>
            </div>
          </div>
        );
      }

      return items.map((reqItem, idx) => (
        <div key={idx} style={{ marginBottom: "10px", minHeight: "3.2rem" }}>
          <div style={textStyle}>
            {reqItem.materialName}
            <br />({reqItem.materialId})
          </div>
        </div>
      ));
    };

    return (
      <>
        {mainItems.length === 0 && accessoryItems.length === 0 ? (
          <span style={{ color: "#6F7171" }}>--</span>
        ) : (
          <>
            {mainItemsAssigned && mainItemsAssigned.length > 0
              ? renderItems(mainItems)
              : mainItems && mainItems.length > 0
              ? renderItems(mainItems)
              : null}
            {accessoryItemsAssigned && accessoryItemsAssigned.length > 0
              ? renderItems(accessoryItems)
              : accessoryItems && accessoryItems.length > 0
              ? renderItems(accessoryItems)
              : null}
          </>
        )}
      </>
    );
  };

  return (
    <div className="hardware-approval-container">
      {notification}
      <Spacer top="10px" />
      <Breadcrumbs surface="light">
        <BreadcrumbItem key={0} active={false}>
          <span
            css={{
              fontWeight: "400",
              color: "black",
            }}
            onClick={() => {
              handleChangePage({ index: 0 });
              messageBus.trigger("closeAccordions");
            }}
          >
            Hardware Approval
          </span>
        </BreadcrumbItem>
        <BreadcrumbItem key={1} active={false}>
          <span
            css={{
              fontWeight: "700",
              color: "black",
            }}
          >
            Hardware Approval Details
          </span>
        </BreadcrumbItem>
      </Breadcrumbs>
      <br />
      {/* Header */}
      <div className="header" style={{ fontFamily: "Verizon-NHG-eTX" }}>
        <h1>Hardware Approval Request {requestData?.id}</h1>
        <div className="header-actions">
          <Button
            style={{ marginLeft: "0.5rem" }}
            role="button"
            size="small"
            aria-label="saveButton"
            onClick={handleUseCurrent}
            disabled={isCancelled || isButtonDisabled}
            className={!isCancelled && !isButtonDisabled ? "useCurrent" : ""}
          >
            Use Current
          </Button>
          <Button
            style={{ marginLeft: "0.5rem" }}
            role="button"
            size="small"
            variant="secondary"
            aria-label="saveButton"
            onClick={handleSendApproval}
            disabled={isCancelled || !request || requestData?.status !== "CREATED"}
          >
            Send Approval
          </Button>
        </div>
      </div>
      <div className="header-details" style={{ fontFamily: "Verizon-NHG-eTX" }}>
        <div className="detail-item">
          <strong>Request</strong> <span className="textDecoratoin">{requestData.id}</span>
        </div>
        <div className="detail-item">
          <strong>Bundle</strong>
          <span className="bundle-tooltip" data-pr-tooltip={tooltipContent}>
            {requestData.bundle}
          </span>
        </div>
        <div className="detail-item">
          <strong>Order</strong>
          <span
            style={{ textDecoration: "underline", cursor: "pointer" }}
            className="textDecoration"
            onClick={() => onHyperLinkClick(requestData, "Order")}
            role="link"
            tabIndex={0}
            onKeyPress={(e) => e.key === "Enter" && onHyperLinkClick(requestData, "Order")}
          >
            {requestData.order}
          </span>
        </div>
        <div className="detail-item">
          <strong>Account Name</strong> {requestData.accountName}
        </div>
        <div className="detail-item">
          <strong>Deployment Service Agent</strong> {requestData.deploymentAgent}
        </div>
        <div className="detail-item">
          <strong>Shipping Address</strong> {requestData.shippingAddress}
        </div>
        <div className="detail-item">
          <strong>Contact</strong> {requestData.contact}
        </div>
        <div className="detail-item">
          <strong>Request Date</strong> {requestData.requestDate}
        </div>
        <div className="detail-item">
          <strong>Status</strong>{" "}
          <span>{String(requestData?.status || "").toUpperCase() === "CLEARED" ? "Cleared" : HARDWARE_REQUEST_STATUS[requestData.status]}</span>
        </div>
        <div className="detail-item">
          <strong>Assignee</strong> {requestData.assignee}
        </div>
        <div className="detail-item">
          <strong>Request Resolved Date</strong> {requestData.resolvedDate}
        </div>
      </div>
      {isLoading ? (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            // backgroundColor: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 100,
          }}
        >
          <Loader active={true} size="large" />
        </div>
      ) : request ? (
        <>
          {/* Vehicle Information Header */}

          <div className="vehicle-info-header" style={{ fontFamily: "Verizon-NHG-eTX" }}>
            <div className="vehicle-title">
              {request.vehicle.year} {request.vehicle.make} {request.vehicle.model}
            </div>
            <div className="vehicle-details">
              <span>{displayVin && request?.vehicle?.vin && request.vehicle.vin.replace("VIN_", "")}</span>

              <div className="vehicle-traits">
                {Object.keys(traitToIconMap).map((traitName, index) => {
                  if (request.vehicle[traitName] == true) {
                    const iconProps = traitToIconMap[traitName];

                    if (iconProps) {
                      return (
                        <Icon
                          key={index}
                          name={iconProps.name}
                          className={iconProps.className}
                          aria-label={iconProps.ariaLabel}
                          alt={iconProps.ariaLabel}
                          size="Large" // Shared property
                          color="#000000" // Shared property
                          style={{ outline: "none", width: "1.3rem", blockSize: "1.3rem" }} // Shared property
                        />
                      );
                    }
                  } else {
                    return;
                  }
                })}
              </div>
              <span className="vehicle-class">{request.vehicle.class}</span>
              <div className={uploadStyles.imageGrid2}>
                {currentImages.map((fileData) => (
                  <div key={fileData.id} className={uploadStyles.fileContainer}>
                    <div className={uploadStyles.imageItem2} onClick={() => handlePreviewClick(fileData)}>
                      {fileData.type.startsWith("image/") ? (
                        fileData.src ? (
                          <img src={fileData.src} alt={fileData.name} className={uploadStyles.uploadedImage} />
                        ) : (
                          <img
                            src={"https://placehold.co/150x150/cccccc/333333?text=No+Image"}
                            alt="No image available"
                            className={uploadStyles.dummyImageIcon}
                          />
                        )
                      ) : (
                        // This is for non-image types like PDFs
                        <img src={pdfIcon} alt={`PDF: ${fileData.name}`} className={uploadStyles.pdfPlaceholderIcon} />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="hardware-table">
            <table style={{ fontFamily: "Verizon-NHG-eTX" }}>
              <thead>
                <tr>
                  <th style={{ width: "8%" }}>Type</th>
                  <th style={{ width: "11%" }}>Subscription</th>
                  <th style={{ width: "20%" }}>Assigned Hardware</th>
                  <th style={{ width: "20%" }}>Requested Hardware</th>
                  <th style={{ width: "8%" }}>Line Type</th>
                  <th style={{ width: "20%" }}>Approval Hardware</th>
                  <th style={{ width: "14%" }}>Approval Actions</th>
                </tr>
              </thead>
              <tbody>
                {/* CORRECTED: Create a sorted copy of the array before mapping */}
                {request?.subscriptions &&
                  [...request.subscriptions]
                    .sort((a, b) => {
                      const typeOrder = {
                        core: 0,
                        companion: 1,
                        feature: 2,
                      };

                      const aOrder = typeOrder[a?.type?.toLowerCase()] ?? 99;
                      const bOrder = typeOrder[b?.type?.toLowerCase()] ?? 99;

                      return aOrder - bOrder;
                    })
                    .map((subscription, subscriptionIndex) => {
                      const locked = isSubscriptionLocked(subscription.subscriptionId);
                      return (
                        <tr key={subscription.subscriptionId}>
                          <td>
                            <span className={`badge ${subscription?.type?.toLowerCase()}`}>
                              {subscription?.type ? subscription?.type.charAt(0)?.toUpperCase() + subscription?.type?.slice(1).toLowerCase() : "--"}
                            </span>
                          </td>
                          <td>
                            <p style={{ fontWeight: 700 }}>{subscription.name}</p>
                            <p style={{ color: "#6F7171", paddingTop: "4px" }}>Subscription ID: {subscription.subscriptionId}</p>
                            <p style={{ color: "#6F7171", paddingTop: "4px" }}>Tech Ref ID: {subscription.techRefId}</p>
                          </td>
                          <td style={{ fontSize: "1rem", lineHeight: "1.6rem" }}>
                            {(() => {
                              // Sort assigned hardware so that subType "Main" comes first
                              const assignedForSub =
                                requestVehicle?.assignedHardwareMapping?.filter((item) => item.subscriptionId === subscription.subscriptionId) || [];
                              const sortedAssigned = [...assignedForSub].sort((a, b) => {
                                const aMain = String(a?.subType || "").toLowerCase() === "main";
                                const bMain = String(b?.subType || "").toLowerCase() === "main";
                                if (aMain === bMain) return 0;
                                return aMain ? -1 : 1;
                              });

                              return sortedAssigned.map((device, deviceIndex) => (
                                <div key={deviceIndex}>
                                  {Array.isArray(device)
                                    ? device?.map((item, itemIndex) => {
                                        const grayStyle =
                                          item?.lineType == "Fulfill" ? { opacity: 0.8, color: "#6F7171", marginBottom: "10px" } : undefined;
                                        return (
                                          <span key={itemIndex} style={grayStyle}>
                                            {item.materialName}
                                            <br />
                                            {item.materialId}
                                            {itemIndex < device.length - 1 && (
                                              <>
                                                <br />
                                                <br />
                                              </>
                                            )}
                                          </span>
                                        );
                                      })
                                    : (() => {
                                        const grayStyle =
                                          device?.lineType == "Fulfill" || requestData?.status !== "CREATED" ? { color: "#6F7171" } : undefined;
                                        return (
                                          <span style={grayStyle}>
                                            {device?.materialName}
                                            <br />
                                            {device?.materialId ? `(${device?.materialId})` : ""}
                                          </span>
                                        );
                                      })()}
                                </div>
                              ));
                            })()}
                          </td>
                          <td style={{ fontSize: "1rem", lineHeight: "1.6rem" }}>
                            {requestData?.status !== "CREATED"
                              ? renderRequestedHardwareMapping(requestVehicle, subscription)
                              : (() => {
                                  // 1. Get Lists
                                  const assignedForSub =
                                    requestVehicle?.assignedHardwareMapping?.filter(
                                      (a) => String(a.subscriptionId) === String(subscription.subscriptionId)
                                    ) || [];

                                  const requestedForSub =
                                    requestVehicle?.requestedHardwareMapping?.filter(
                                      (r) => String(r.subscriptionId) === String(subscription.subscriptionId)
                                    ) || [];

                                  // 2. Sort Both Lists (Main First) to ensure VDD aligns with VDD
                                  const sortMainFirst = (list) => {
                                    return [...list].sort((a, b) => {
                                      const aMain = String(a?.subType || "").toLowerCase() === "main";
                                      const bMain = String(b?.subType || "").toLowerCase() === "main";
                                      if (aMain === bMain) return 0;
                                      return aMain ? -1 : 1;
                                    });
                                  };

                                  const sortedAssigned = sortMainFirst(assignedForSub);
                                  const sortedRequested = sortMainFirst(requestedForSub);

                                  // 3. Alignment Logic
                                  let reqIdx = 0; // Pointer for requested items

                                  const alignedRows = sortedAssigned.map((assignedItem, index) => {
                                    const currentReq = sortedRequested[reqIdx];
                                    const subType = String(assignedItem?.subType || "");

                                    // A. YOUR SPECIFIC LOGIC: Check First Row / Main Alignment
                                    // If we are at index 0 (Main), but the candidate requested item ISN'T Main,
                                    // we return null (--) and do NOT consume the requested item (wait for next row).
                                    if (index === 0 && subType === "Main" && currentReq?.subType !== "Main") {
                                      return null;
                                    }

                                    // B. FULFILL LOGIC: Push Down
                                    // If Assigned Line is Fulfill, we show "--" (Gray).
                                    // We do NOT increment reqIdx, so the current requested item (e.g. Y-Cable)
                                    // is pushed to the next available slot (or the bottom).
                                    const lt = String(assignedItem?.lineType || "")
                                      .trim()
                                      .toLowerCase();
                                    if (lt.includes("fulfill")) {
                                      return null;
                                    }

                                    // C. Match
                                    // If we haven't skipped it, we take the current requested item.
                                    if (currentReq) {
                                      reqIdx++; // Move pointer to next requested item
                                      return currentReq;
                                    }

                                    return null;
                                  });

                                  // 4. Gather Remaining Items (The ones pushed down)
                                  const remainingItems = sortedRequested.slice(reqIdx);
                                  const finalDisplayList = [...alignedRows, ...remainingItems];

                                  // 5. Render
                                  if (!finalDisplayList.length && !sortedAssigned.length) {
                                    return <span style={{ color: "#6F7171" }}>--</span>;
                                  }

                                  return finalDisplayList.map((reqItem, idx) => {
                                    const isPlaceholder = !reqItem;
                                    const textStyle = { color: requestData?.status !== "CREATED" ? "#6F7171" : "#000" };

                                    return (
                                      <div key={idx} style={{ marginBottom: "10px", minHeight: "3.2rem" }}>
                                        {isPlaceholder ? (
                                          <span style={{ color: "#6F7171" }}>--</span>
                                        ) : (
                                          <div style={textStyle}>
                                            {reqItem.materialName}
                                            <br />({reqItem.materialId})
                                          </div>
                                        )}
                                      </div>
                                    );
                                  });
                                })()}
                          </td>

                          <td style={{ fontSize: "1rem", lineHeight: "1.6rem" }}>
                            {(() => {
                              const assignedForSub =
                                requestVehicle?.assignedHardwareMapping?.filter((item) => item.subscriptionId === subscription.subscriptionId) || [];
                              // Sort so that subType "Main" appears first
                              const sortedAssigned = assignedForSub.sort((a, b) => {
                                const aMain = String(a?.subType || "").toLowerCase() === "main";
                                const bMain = String(b?.subType || "").toLowerCase() === "main";
                                if (aMain === bMain) return 0;
                                return aMain ? -1 : 1;
                              });

                              return sortedAssigned?.map((device, deviceIndex) => (
                                <div key={deviceIndex}>
                                  {(() => {
                                    const lt = String(device?.lineType || "")
                                      .trim()
                                      .toLowerCase();
                                    const isFulfill = lt.includes("fulfill");
                                    const style =
                                      isFulfill || requestData?.status !== "CREATED" ? { opacity: 0.8, color: "#6F7171" } : { color: "#000" };
                                    return <span style={style}>{device?.lineType ? device.lineType : "--"}</span>;
                                  })()}
                                  <br />
                                  <br />
                                </div>
                              ));
                            })()}
                          </td>
                          <td style={{ fontSize: "1rem", lineHeight: "1.6rem", verticalAlign: "top" }}>
                            {requestData?.status !== "CREATED"
                              ? renderApprobvedHardwareMapping(requestVehicle, subscription)
                              : (() => {
                                  // -----------------------------------------------------------------------
                                  // 1. SETUP & SORTING
                                  // -----------------------------------------------------------------------
                                  const assignedForSub =
                                    requestVehicle?.assignedHardwareMapping?.filter(
                                      (a) => String(a.subscriptionId) === String(subscription.subscriptionId)
                                    ) || [];

                                  const requestedForSub =
                                    requestVehicle?.requestedHardwareMapping?.filter(
                                      (r) => String(r.subscriptionId) === String(subscription.subscriptionId)
                                    ) || [];

                                  const approvedForSub =
                                    requestVehicle?.approvedHardwareMapping?.filter(
                                      (a) => String(a.subscriptionId) === String(subscription.subscriptionId)
                                    ) || [];

                                  // Sort Helper: Main First
                                  const sortMainFirst = (list) => {
                                    return [...list].sort((a, b) => {
                                      const aMain = String(a?.subType || "").toLowerCase() === "main";
                                      const bMain = String(b?.subType || "").toLowerCase() === "main";
                                      if (aMain === bMain) return 0;
                                      return aMain ? -1 : 1;
                                    });
                                  };

                                  const sortedAssigned = sortMainFirst(assignedForSub);
                                  const sortedRequested = sortMainFirst(requestedForSub);

                                  // Mutable pool of approved items (we will remove items from here as we find matches)
                                  let approvedPool = sortMainFirst(approvedForSub);

                                  // -----------------------------------------------------------------------
                                  // 2. BUILD ALIGNED ROW STRUCTURE (Matches Requested Column Logic)
                                  // -----------------------------------------------------------------------
                                  let reqIdx = 0;
                                  const alignedRows = sortedAssigned.map((assignedItem, index) => {
                                    const currentReq = sortedRequested[reqIdx];
                                    const subType = String(assignedItem?.subType || "");

                                    // Logic A: Main Check
                                    if (index === 0 && subType === "Main" && currentReq?.subType !== "Main") {
                                      return null; // Placeholder
                                    }
                                    // Logic B: Fulfill Check
                                    const lt = String(assignedItem?.lineType || "")
                                      .trim()
                                      .toLowerCase();
                                    if (lt.includes("fulfill")) {
                                      return null; // Placeholder
                                    }
                                    // Logic C: Match
                                    if (currentReq) {
                                      reqIdx++;
                                      return currentReq;
                                    }
                                    return null;
                                  });

                                  const remainingRequested = sortedRequested.slice(reqIdx);

                                  // This defines the "Slots" we must render to align with the other columns
                                  const finalDisplayList = [...alignedRows, ...remainingRequested];

                                  // -----------------------------------------------------------------------
                                  // 3. DROPDOWN OPTIONS (For CREATED Status)
                                  // -----------------------------------------------------------------------
                                  const materialsForSubscription = groupedRecomendationsSubscriptionId[subscription.subscriptionId];
                                  const searchableMaterials =
                                    materialsForSubscription
                                      ?.filter((item) => String(item.materialId)?.startsWith("11") && !item.isObsolete)
                                      .map((item) => ({
                                        ...item,
                                        searchableLabel: `${item.materialName} (${item.materialId})`,
                                      })) || [];

                                  searchableMaterials.unshift({
                                    materialId: "",
                                    materialName: "Select Hardware",
                                    searchableLabel: "Select Hardware",
                                  });

                                  const materialOptionTemplate = (option) => (
                                    <div>
                                      {option.materialName === "Select Hardware"
                                        ? option.materialName
                                        : `${option.materialName} (${option.materialId})`}
                                    </div>
                                  );
                                  const selectedMaterialTemplate = (option) =>
                                    option && (
                                      <div>
                                        {option.materialName === "Select Hardware"
                                          ? option.materialName
                                          : `${option.materialName} (${option.materialId})`}
                                      </div>
                                    );

                                  // -----------------------------------------------------------------------
                                  // 4. RENDER FUNCTION
                                  // -----------------------------------------------------------------------
                                  const rowStyle = {
                                    marginBottom: "10px",
                                    minHeight: "3.2rem",
                                    display: "flex",
                                    alignItems: "center",
                                  };

                                  const renderApprovedText = (item, key) => {
                                    const isReadOnly = requestData?.status !== "CREATED";
                                    const dashStyle = isReadOnly
                                      ? { opacity: 0.8, color: "#6F7171", fontSize: "1rem" }
                                      : item?.lineType != null
                                      ? { opacity: 0.8, color: "#6F7171", fontSize: "1rem" }
                                      : { color: "#000", fontSize: "1rem" };
                                    return (
                                      <div key={key} style={rowStyle}>
                                        <div style={dashStyle}>
                                          {item.materialName}
                                          <div style={{ marginTop: "4px" }}>({item.materialId})</div>
                                        </div>
                                      </div>
                                    );
                                  };

                                  // --- PART A: Render the Aligned Rows (Slots) ---
                                  const renderedSlots = finalDisplayList.map((reqItem, idx) => {
                                    const assignedRef = sortedAssigned[idx];

                                    // >>> STATUS: CREATED (EDIT MODE)
                                    if (requestData?.status === "CREATED") {
                                      // If it's a placeholder (e.g. Fulfill line), show --
                                      if (!reqItem) {
                                        return (
                                          <div key={idx} style={rowStyle}>
                                            <span style={{ color: "#6F7171" }}>--</span>
                                          </div>
                                        );
                                      }

                                      const mId = reqItem.materialId;
                                      const selectedValue = hardwareSelections[subscription.subscriptionId]?.[mId] ?? mId ?? "";

                                      return (
                                        <div key={idx} style={rowStyle}>
                                          <Dropdown
                                            value={selectedValue}
                                            onChange={(e) => {
                                              const selectedMaterialId = e.value;
                                              setHardwareSelections((prev) => ({
                                                ...prev,
                                                [subscription.subscriptionId]: {
                                                  ...prev[subscription.subscriptionId],
                                                  [mId]: selectedMaterialId,
                                                },
                                              }));
                                              if (getAddMaterialSubscriptionsList && cspData?.CSP?.[0]?.Opp_Sales_Org) {
                                                getAddMaterialSubscriptionsList(subscription.subscriptionId, cspData.CSP[0].Opp_Sales_Org);
                                              }
                                            }}
                                            options={searchableMaterials}
                                            optionLabel="materialName"
                                            optionValue="materialId"
                                            placeholder="Select Hardware"
                                            filter
                                            filterBy="searchableLabel"
                                            style={{ width: "100%", fontFamily: "Verizon-NHG-eTX" }}
                                            itemTemplate={materialOptionTemplate}
                                            valueTemplate={selectedMaterialTemplate}
                                          />
                                        </div>
                                      );
                                    }

                                    // >>> STATUS: READ ONLY (PENDING/APPROVED/CLOSED)
                                    else {
                                      let displayItem = null;
                                      let approvedMatchIndex = -1;

                                      if (reqItem) {
                                        // 1. Try Exact ID Match
                                        approvedMatchIndex = approvedPool.findIndex((a) => String(a.materialId) === String(reqItem.materialId));

                                        // 2. Try SubType Match (Swap logic)
                                        if (approvedMatchIndex === -1) {
                                          const targetSubType = String(reqItem.subType || assignedRef?.subType || "accessory").toLowerCase();
                                          approvedMatchIndex = approvedPool.findIndex((a) => String(a.subType || "").toLowerCase() === targetSubType);
                                        }
                                      }

                                      // If match found, remove from pool so it's not reused
                                      if (approvedMatchIndex !== -1) {
                                        [displayItem] = approvedPool.splice(approvedMatchIndex, 1);
                                      }

                                      // Fallback: If Pending Agent and no approved match, show the Requested Item
                                      if (!displayItem && reqItem) {
                                        const statusUpper = String(requestData?.status || "").toUpperCase();
                                        if (statusUpper.includes("PENDING") && !approvedForSub.length) {
                                          displayItem = reqItem;
                                        }
                                      }

                                      if (displayItem) {
                                        return renderApprovedText(displayItem, idx);
                                      }

                                      return (
                                        <div key={idx} style={rowStyle}>
                                          <span style={{ color: "#6F7171" }}>--</span>
                                        </div>
                                      );
                                    }
                                  });

                                  // --- PART B: Render Leftover Approved Items (The Extras) ---
                                  // If the approvedPool still has items (because approved count > aligned slot count), render them now.
                                  // This fixes the issue of "showing only two" when there are 3 approved items.
                                  const renderedExtras = approvedPool.map((extraItem, idx) => {
                                    // Only render extras in Read-Only mode (Created mode relies on AddedMaterials)
                                    if (requestData?.status === "CREATED") return null;
                                    return renderApprovedText(extraItem, `extra-${idx}`);
                                  });

                                  const finalOutput = [...renderedSlots, ...renderedExtras];

                                  if (!finalOutput.length && !sortedAssigned.length) {
                                    return (
                                      <div style={rowStyle}>
                                        <span style={{ color: "#6F7171" }}>--</span>
                                      </div>
                                    );
                                  }

                                  return finalOutput;
                                })()}

                            {/* Added Materials (Manual Additions) */}
                            {addedMaterials
                              ?.filter((mat) => mat.subscriptionId === subscription.subscriptionId)
                              ?.map((addedItem) => (
                                <div
                                  key={addedItem.id}
                                  style={{ marginBottom: "10px", marginTop: "10px", border: "solid 1px #ccc", backgroundColor: "#f0f0f0" }}
                                >
                                  <div style={{ padding: "12px", minHeight: "44px", backgroundColor: "#fff", fontSize: "1rem", color: "#000" }}>
                                    {addedItem.materialName} ({addedItem.materialId})
                                  </div>
                                </div>
                              ))}
                          </td>
                          {subscriptionIndex === 0 && (
                            <td rowSpan={request.subscriptions.length} style={{ verticalAlign: "top" }}>
                              <div className="comments-section">
                                <p>Comments</p>
                                <textarea
                                  value={comments || requestData?.approvalComments}
                                  onChange={(e) => setComments(e.target.value)}
                                  required={commentsAreMandatory()}
                                  style={{ resize: "none" }}
                                  maxLength={200}
                                  disabled={requestData?.status !== "CREATED"}
                                ></textarea>
                                <p className="char-count">{comments.length}/200</p>
                                {commentError && <p className="error-message">{commentError}</p>}
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <b>Reason for Changing:</b>
                    <br />
                    {requestData.reasonForChange}
                  </td>
                  <td>
                    <div
                      style={{
                        fontWeight: 700,
                        textDecoration: "underline",
                        fontSize: "12px",

                        ...(isCancelled || isDisabled ? { pointerEvents: "none", opacity: 0.6, cursor: "not-allowed" } : { cursor: "pointer" }),
                      }}
                      tabIndex={isCancelled || isDisabled ? -1 : 0}
                      aria-disabled={isCancelled || isDisabled}
                      onClick={() => {
                        if (!isCancelled && !isDisabled) {
                          setIsAddMaterialModalOpen(true);
                        }
                      }}
                    >
                      Add Material
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>Comments:</strong>
                    <br />
                    {requestData.deploymentAgentComments}
                  </td>
                  <td> </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div>No request data available.</div>
      )}

      <Tooltip target=".bundle-tooltip" />
      {/* Render the Modal component */}
      <Modal show={showModal} onClose={() => setShowModal(false)}>
        {modalContent}
      </Modal>

      {isAddMaterialModalOpen && (
        <AddMaterial
          isOpen={isAddMaterialModalOpen}
          onClose={() => {
            setIsAddMaterialModalOpen(false);
          }}
          recommendations={currentVehicleApiData?.materialMapping} // selected requested hardwares
          handleAddMaterial={(addedMaterials) => {
            setAddedMaterials(addedMaterials);
            hasAnyHardwareChanged(addedMaterials);
          }}
          addedMaterials={addedMaterials}
          salesOrg={cspData.CSP?.[0]?.Opp_Sales_Org}
          existingHardwareMap={existingHardwareMapForModal} //selected approval material based on subscription
          materialList={filterSelectedd(selectedAddMaterialsGroupedSubs)} // all grouped subscription apprval materail list
          getContractDetailsApiToBeCalled={true}
          onChangeSubscriptionId={(subId) => handleGetContractDetails(subId)}
        />
      )}
    </div>
  );
};

export default EditHardwareRequestComponent;

export const EditHardwareRequestMetadata = {
  name: "Edit Hardware Request",
  id: "edit_hardware_request",
  component: lazy(() => import("./EditHardwareRequestComponent")),
  route: "/connect360/edit_hardware_request",
  Breadcrumbs: true,
};
